import script from "./CompanySwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanySwitcher.vue?vue&type=script&setup=true&lang=js"

import "./CompanySwitcher.vue?vue&type=style&index=0&id=0bfa54aa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bfa54aa"]])

export default __exports__